import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import {
	StyledSelect,
	Label,
	ButtonValue,
	ButtonIcon,
	Color,
	Options,
	OptionsHeader,
	OptionsListWrapper,
	OptionsList,
	OptionsListItem,
	ButtonOption,
	ButtonBack,
	ListTypeOption,
} from './styles';
import { LIST_TYPE } from '../../RichTextEditor/helpers/constants';
import Utils from '../../../../utils';

interface SelectProps {
	label: string;
	value: string;
	options: {
		values: string[];
		label: string | React.ReactNode;
		displayedLabel?: React.ReactNode;
	}[];
	onChange: (param: string) => void;
	isFontSelect?: boolean;
	isColorSelect?: boolean;
	isLineHeightSelect?: boolean;
	isListTypeSelect?: boolean;
	optionsLabel?: string;
}

const Select = ({
	label,
	value,
	options,
	onChange,
	isColorSelect,
	isFontSelect,
	isLineHeightSelect,
	isListTypeSelect,
	optionsLabel,
}: SelectProps) => {
	const [isOptionsDisplayed, setIsOptionsDisplayed] = React.useState(false);

	const getSelectedValue = (value: string): string | React.ReactNode => {
		if (isFontSelect) {
			return (
				<span style={{ fontFamily: value }}>
					{value.split(',')[0].replace(/\'|\"/g, '')}
				</span>
			);
		}

		if (isColorSelect) {
			return <Color style={{ backgroundColor: value }}/>;
		}

		if (isLineHeightSelect && value === 'normal') {
			return <Translate value="messages.normal" />;
		}

		if (isListTypeSelect && value !== LIST_TYPE.NONE) {
			const icon = value === LIST_TYPE.ORDERED
				? 'iconset_uprez_numbered_list'
				: 'iconset_uprez_bulleted_list';

			return (
				<ListTypeOption>
					{Utils.getSvgIcon(icon)}
				</ListTypeOption>
			);
		}

		const selectedOption = options.find(({ values }) => values.includes(value));

		return selectedOption ? selectedOption.label : value;
	};

	return (
		<StyledSelect>
			<Label value={label} />
			<ButtonValue
				type="button"
				onClick={() => setIsOptionsDisplayed(true)}
			>
				{getSelectedValue(value)}
			</ButtonValue>
			<ButtonIcon
				type="button"
				onClick={() => setIsOptionsDisplayed(true)}
			>
				{Utils.getSvgIcon('iconset_back')}
			</ButtonIcon>
			{isOptionsDisplayed &&
				<Options>
					<OptionsHeader>
						<ButtonBack
							type="button"
							onClick={() => setIsOptionsDisplayed(false)}
						>
							{Utils.getSvgIcon('iconset_back')}
							<Translate value="messages.back" />
						</ButtonBack>
						<Translate value={optionsLabel || label} />
					</OptionsHeader>
					<OptionsListWrapper>
						<OptionsList>
							{options.map(option => {
								const isSelected = option.values.includes(value);
								const handleClick = () => {
									onChange(option.values[0]);
								};

								return (
									<OptionsListItem key={option.values[0]}>
										<ButtonOption
											type="button"
											onClick={handleClick}
										>
											{isSelected && Utils.getSvgIcon('iconset_uprez_check')}
											{option.displayedLabel || option.label}
										</ButtonOption>
									</OptionsListItem>
								);
							})}
						</OptionsList>
					</OptionsListWrapper>
				</Options>
			}
		</StyledSelect>
	);
};

export default Select;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/Select/index.tsx